//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import { numeric } from 'vuelidate/lib/validators'
export default {
  name: 'rb-custom-phone',
  props: {
    prefix: {
      type: String,
      default: '',
    },
  },
  validations() {
    return {
      phoneField: {
        numeric,
      },
    }
  },

  data() {
    return {
      phoneField: '',
    }
  },
  computed: {
    ...mapGetters(['translation']),
  },
  watch: {
    phoneField(newVal) {
      this.$v.phoneField.$touch()
      const isValid = !this.$v.phoneField.$invalid
      this.$emit('changedPhone', { value: newVal, isValid })
    },
  },
}
